import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { SpinnerDialogComponent } from '../../dialogs/spinner-dialog/spinner-dialog.component';

@Component({
  selector: 'app-amazon',
  templateUrl: './amazon.component.html',
  styleUrls: ['./amazon.component.css']
})
export class AmazonComponent {
  detailForm: FormGroup;
  spinner: MatDialogRef<SpinnerDialogComponent>;

  constructor(
    private http: HttpService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
  ) {
    this.detailForm = this.formBuilder.group({
      infoField1: [null, Validators.required],
    });
  }


  // tslint:disable-next-line:typedef
  submitForm($event) {
    console.log($event);
    const formValue = this.detailForm.getRawValue();
    console.log(formValue);
    const infoField1 = formValue.infoField1;
    if (infoField1) {
      this.spinner = this.dialog.open(SpinnerDialogComponent, {
        panelClass: 'transparent',
        disableClose: true
      });
      const data = {
        operation: 'GetUserId',
        infoField1
      };
      this.http.checkAmazonUser(data).subscribe( res => {
        this.spinner.close();
        console.log(`res ${JSON.stringify(res)}`);
      }, err => {
        this.spinner.close();
      });
    }
  }
}
